import React from 'react';
import Link from 'next/link';
import Button, { ButtonOwnProps } from '@mui/material/Button';
import { DEFAULT_CANDIDATES_ME_ROUTER_PATH } from '@/constants/router-path';
import { trackClickEvent } from '@/utils/site-track';

const CreateResumeBtn = (props: {
  dataEleGroup: string;
  variant?: ButtonOwnProps['variant'];
}) => {
  const { dataEleGroup, variant = 'contained' } = props;

  return (
    <Button
      className="w-full h-13.5 max-w-[340px] !font-semibold tablet:w-[220px]"
      variant={variant}
      data-ele-id="btn_创建简历"
      data-ele-group={dataEleGroup}
      LinkComponent={Link}
      href={DEFAULT_CANDIDATES_ME_ROUTER_PATH}
      onClick={(e) => trackClickEvent(e)}
    >
      创建简历
    </Button>
  );
};

export default CreateResumeBtn;
